@if (showSpinner) {
<app-loader> </app-loader>
}
<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  @if (isavailablefeature('isView')) {
  <div class="container-fluid mb-4 ">
    <!-- Combined Header and Filter Section -->
    <div class="combined-header-filter-section" [ngClass]="{ 'dark-mode': selectedMode === 'dark' }">
      <!-- Header Content -->
      <div class="header-content">
        <div class="title-section">
          <div class="title-wrapper">
            <div class="title-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
                <path d="M8 14h.01"></path>
                <path d="M12 14h.01"></path>
                <path d="M16 14h.01"></path>
              </svg>
            </div>
            <div class="title-text-container">
              <h1 class="main-title">Attendance Request Management</h1>
              <p class="subtitle">Track and manage employee attendance requests</p>
            </div>
          </div>
        </div>


      </div>



       <!-- Filter Toggle Button with Action Buttons -->
      <div class="filter-toggle-section">
        <button class="filter-toggle-btn" (click)="toggleFilterSection()" [attr.aria-expanded]="isFilterExpanded">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="filter-icon">
            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
          </svg>
          <span>{{ isFilterExpanded ? 'Hide Filters' : 'Show Filters' }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="chevron-icon" [class.rotated]="isFilterExpanded">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </button>

          <div class="action-controls">
                <button type="button" class="control-btn apply-btn" (click)="getAttendanceRequests()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                  Apply Filters
                </button>

                <button type="button" class="control-btn reset-btn" (click)="resetfilter()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <polyline points="1 4 1 10 7 10"></polyline>
                          <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>
                        </svg>
                        Reset
                </button>
            </div>
      </div>




      <!-- Filter Content -->
      <div class="filter-content" [@slideDown]="isFilterExpanded ? 'expanded' : 'collapsed'" *ngIf="isFilterExpanded">

        <div class="search-filters">
          <div class="input-group">
            <label>Start Date</label>
            <div class="input-wrapper date-wrapper">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
              <input type="date" [(ngModel)]="startDateFilter" />
            </div>
          </div>

          <div class="input-group">
            <label>End Date</label>
            <div class="input-wrapper date-wrapper">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
              <input type="date" [(ngModel)]="endDateFilter" />
            </div>
          </div>


          <div class="input-group">
            <label>Select Month</label>
            <div class="input-wrapper">
              <select [(ngModel)]="useLastMonth">
                <option value="">Current Month</option>
                <option value="last_month">Last Month</option>
              </select>
            </div>
          </div>
        </div>




      </div>
    </div>

    <!-- Modern Card-Based Attendance Request Listing -->
    <div class="leaves-grid-container">
      @for (a of arr ; track a) {
      <div class="leave-card" [ngClass]="{
        'card-approved': a.status === 'approved',
        'card-rejected': a.status === 'rejected',
        'card-pending': a.status === 'pending',
        'dark-card': selectedMode === 'dark'
      }">

        <!-- Card Header - Employee Info & Actions -->
        <div class="card-header-section">
          <div class="employee-info">
            <div class="employee-avatar">
              @if (a.user?.profile_image) {
              <div class="avatar">
                <img [src]="a.user.profile_image" alt="Profile Image">
              </div>
              }
              @else {
              <div class="avatar-initials">
                {{ (a.user?.first_name?.charAt(0) || '') + (a.user?.last_name?.charAt(0) || '') }}
              </div>
              }
            </div>
            <div class="employee-details">
              <h3 class="employee-name">{{ a.name }}</h3>
              <div class="employee-meta-inline">
                <span class="meta-item">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                  ID: {{ a.attendance_id }}
                </span>

                <!-- Request Type Badge -->
                <div class="leave-type-badge-wrapper">
                  <div class="leave-type-badge">
                    <span class="leave-type-name">{{ a.type | titlecase }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

         
        </div>

        <!-- Card Body - Attendance Request Details -->
        <div class="card-body-section">
          <!-- Compact Details Row -->
          <div class="details-compact">
            <div class="detail-item-compact">
              <div class="detail-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
              </div>
              <div class="detail-content-compact">
                <span class="detail-label-compact">Date:</span>
                <span class="detail-value-compact">{{ a.date | date: 'd MMM yyyy' }}</span>
              </div>
            </div>

            <div class="detail-item-compact">
              <div class="detail-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
              </div>
              <div class="detail-content-compact">
                <span class="detail-label-compact">Type:</span>
                <span class="detail-value-compact">{{ a.type | titlecase }}</span>
              </div>
            </div>

            <!-- Applied Date -->
            <div class="detail-item-compact">
              <div class="detail-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                  <path d="M8 14h.01"></path>
                  <path d="M12 14h.01"></path>
                  <path d="M16 14h.01"></path>
                </svg>
              </div>
              <div class="detail-content-compact">
                <span class="detail-label-compact">Applied:</span>
                <span class="detail-value-compact">{{ a.created_at | date: 'd MMM yyyy' }}</span>
              </div>
            </div>
          </div>

          <!-- Two Column Layout: Description (Left) + Timeline (Right) -->
          <div class="content-two-column">
            <!-- Left Column: Description & Admin Info -->
            <div class="left-column">
              <!-- Description -->
              <div class="description-section-compact">
                <div class="description-header-compact">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14,2 14,8 20,8"></polyline>
                    <line x1="16" y1="13" x2="8" y2="13"></line>
                    <line x1="16" y1="17" x2="8" y2="17"></line>
                  </svg>
                  <span>Reason</span>
                </div>
                <!-- <p class="description-text-compact">{{ a.reason }}</p> -->
                 <p class="description-text-compact" [innerHTML]="a.reason || a.reason"></p>
              </div>

              <!-- Request Details -->
              <div class="description-section-compact">
                <div class="description-header-compact">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14,2 14,8 20,8"></polyline>
                    <line x1="16" y1="13" x2="8" y2="13"></line>
                    <line x1="16" y1="17" x2="8" y2="17"></line>
                  </svg>
                  <span>Request Details</span>
                </div>
                <div class="request-details">
                  @if (a.type === 'check_in') {
                    <div class="detail-row">
                      <span class="detail-label">Requested Check-in:</span>
                      <span class="detail-value">{{ a.check_in }}</span>
                    </div>
                  }
                  @if (a.type === 'check_out') {
                    <div class="detail-row">
                      <span class="detail-label">Requested Check-out:</span>
                      <span class="detail-value">{{ a.check_out }}</span>
                    </div>
                  }
                  @if (a.type === 'overtime') {
                    <div class="detail-row">
                      <span class="detail-label">Requested Overtime:</span>
                      <span class="detail-value">{{ a.overtime || 'N/A' }}</span>
                    </div>
                  }
                </div>
              </div>

              <!-- Rejected Reason -->
              @if (a.status === 'rejected' && a.rejected_reason) {
              <div class="rejection-section-compact">
                <div class="rejection-header-compact">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="8" x2="12" y2="12"></line>
                    <line x1="12" y1="16" x2="12.01" y2="16"></line>
                  </svg>
                  <span>Rejection Reason</span>
                </div>
                <p class="rejection-text-compact">{{ a.rejected_reason }}</p>
              </div>
              }

              <!-- Admin Info for approved/rejected -->
              @if ((a.status === 'approved' || a.status === 'rejected') && a.admin) {
              <div class="admin-info-section-compact" [ngClass]="{ 'rejected-class': a.status === 'rejected' }">
                <span class="admin-label-compact">{{ a.status === 'approved' ? 'Approved' : 'Rejected' }} by:</span>
                <div class="admin-info-content-compact">
                  <!-- <div class="admin-avatar-small">
                    <span>{{ (a.admin?.first_name?.charAt(0) || 'A') }}</span>
                  </div> -->
                   @if (a.admin?.profile_image) {
                  <div class="admin-avatar-small">
                    <img [src]="a.admin?.profile_image" alt="Profile Image">
                  </div>
                  }
                  @else {
                  <div class="admin-avatar-small">
                    {{ (a.admin?.first_name?.charAt(0) || '') + (a.admin?.last_name?.charAt(0) || '') }}
                  </div>
                  }



                  <div class="admin-details-text">
                    <span class="admin-name-text">{{ a.admin?.first_name }} {{ a.admin?.last_name }}</span>
                    <span class="admin-date-text">{{ a.updated_at | date: 'd MMM yyyy' }}</span>
                  </div>
                </div>
              </div>
              }
            </div>

            <!-- Right Column: Status Timeline -->
            <div class="right-column">
              <div class="status-timeline-compact">
                <div class="timeline-header-compact">
                  <div class="timeline-header-left">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
                    </svg>
                    <span>Approval Timeline</span>
                  </div>

                  <!-- Status Badge in Timeline Header -->
                  <div class="status-badge-timeline" [ngClass]="{
                    'badge-approved': a.status === 'approved',
                    'badge-rejected': a.status === 'rejected',
                    'badge-pending': a.status === 'pending'
                  }">
                    @if (a.status === 'approved') {
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    }
                    @if (a.status === 'rejected') {
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                    }
                    @if (a.status === 'pending') {
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                    }
                    <span>{{ a.status | titlecase }}</span>
                  </div>
                </div>
                <div class="timeline-items-compact">
                  @if (a.status === 'pending') {
                  <div class="timeline-item-compact pending-item">
                    <div style="display: flex; align-items: center; gap: 8px;">
                      <div class="timeline-icon-compact">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <circle cx="12" cy="12" r="10"></circle>
                          <line x1="12" y1="8" x2="12" y2="12"></line>
                          <line x1="12" y1="16" x2="12.01" y2="16"></line>
                        </svg>
                      </div>
                      <div class="timeline-content-compact">
                        <span class="timeline-status-compact">Pending Review</span>
                        <span class="timeline-subtitle-compact">Awaiting approval</span>
                      </div>
                    </div>
                  </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      }
    </div>

    <!-- end modal -->
    <!-- reject modal -->

  </div>
  }
</main>